import { UPDATE_ACTIVE_ITEM } from "../types/globalTypes";

const chooseActive = pathname => {
  switch (pathname) {
    case "/":
      console.log("home");
      return "home";
      break;
    case "/cleanings/":
    case "/cleanings":
      return "My Cleanings";
      break;
    case "/booking":
    case "/booking/":
      return "Booking Page";
      break;
    case "/freecleanings/":
    case "/freecleanings":
      return "freecleanings";
      break;
    case "/login":
    case "/login/":
      return "Login";
      break;

    default:
      return "home";
      break;
  }
};
export const updateActiveItem = pathname => {
  const activeItem = chooseActive(pathname);
  return {
    type: UPDATE_ACTIVE_ITEM,
    payload: activeItem
  };
};



// WEBPACK FOOTER //
// ./src/actions/globalActions.js